// Generated by Copilot- Start
import React from "react";
import DtvModal from "@directv-digital/dds.ui.dtv-modal";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvDivider from "@directv-digital/dds.ui.dtv-divider";
import DtvTheme from "@directv-digital/dds.ui.dtv-theme";
import { ChannelCardV2 } from "lib/helper/channel-interactive-tool-v2";
import ModalChannelHeader from "../shared/ModalChannelHeader";
import ModalPackageSection, { PackageEntry } from "../shared/ModalPackageSection";
import MyFreeDtvBanner from "./MyFreeDtvBanner";
import { dtvModalStyle, dtvModalBodyStyle, dtvModalRootSx } from "../../styles/component-styles";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";

const bps = DtvTheme.breakpoints;

interface MyFreeDtvModalV2Props {
  open: boolean;
  channel?: ChannelCardV2;
  onClose: () => void;
  myFreeDTVObj?: {
    availableText?: string;
    package?: Array<{
      packageName: string;
      packageLegal?: string;
      cta?: {
        label: string;
        ctaUrl: string;
        ctaAccessibility?: string;
      };
    }>;
    myfreeDtvLogo?: string;
    myfreeDtvLogoAltText?: string;
    banner?: {
      content?: string;
    };
    cta?: {
      label: string;
      ctaUrl: string;
      ctaAccessibility?: string;
    };
  };
}

const MyFreeDtvModalV2: React.FC<MyFreeDtvModalV2Props> = ({ open, channel, onClose, myFreeDTVObj }) => {
  try {
    if (!channel) {
      return null;
    }

    if (!myFreeDTVObj || Object.keys(myFreeDTVObj).length === 0) {
      return null;
    }

    if (!myFreeDTVObj.package || myFreeDTVObj.package.length === 0) {
      return null;
    }

    return (
      <DtvModal
        open={open}
        handleClose={onClose}
        modalStyle={dtvModalStyle}
        modalBodyStyle={dtvModalBodyStyle}
        sx={dtvModalRootSx}
      >
        <DtvBox>
          {/* Channel Header with Logo (shared) */}
          <ModalChannelHeader logo={channel.logo} label={channel.label} />

          <DtvDivider sx={{
 mt: {
 xs: "16px",
md: "20px"
},
mb: {
 xs: "16px",
md: "0px"
}
}} />

          <DtvBox
            sx={{
              display: "flex",
              flexDirection: "column",
              [bps.up(bps.values.sm)]: {
                margin: "12px 0px"
              }
            }}
          >
            {/* Package Mapping Section */}
            <DtvBox sx={{ mb: "24px" }}>
              <ModalPackageSection
                id="package-mapping-with-channel"
                heading={myFreeDTVObj.availableText || "Available in"}
                packages={myFreeDTVObj.package.map((pkg, index): PackageEntry => ({
                  id: `myfree-pkg-${index}`,
                  displayLabel: pkg.packageName,
                  packageLegal: pkg.packageLegal || "",
                  ctaObj: pkg.cta ?
                    {
 cta: pkg.cta.label,
ctaUrl: pkg.cta.ctaUrl,
ctaAccessibility: pkg.cta.ctaAccessibility
} :
                    undefined,
                  type: "myfree"
                }))}
                channelName={channel.label}
                channelCategory="myfree"
                topMargin="0px"
              />
            </DtvBox>

            {/* MyFree DIRECTV Banner */}
            <MyFreeDtvBanner
              myfreeDtvLogo={myFreeDTVObj.myfreeDtvLogo}
              myfreeDtvLogoAltText={myFreeDTVObj.myfreeDtvLogoAltText}
              bannerContent={myFreeDTVObj.banner?.content}
              cta={myFreeDTVObj.cta}
            />
          </DtvBox>
        </DtvBox>
      </DtvModal>
    );
  } catch (error) {
    console.error("Error in MyFreeDtvModalV2 >> ", error);
    return <ErrorDisplay error={error} component="My Free DTV Modal V2" />;
  }
};

export default React.memo(MyFreeDtvModalV2);
// Generated by Copilot- End
